import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";

export const emitGiftPointsResultSerializer = Serializers.object({
  totalEmittted: Serializers.decimal,
  affectedAccountCount: Serializers.integer,
});

export type EmitGiftPointsResult = SerializerValue<typeof emitGiftPointsResultSerializer>;

const emitGiftPoints = HttpAction({
  path: "/giftPoints/emit",
  method: "post",
  requiresAuth: true as const,
  bodySerializer: Serializers.object({
    amount: Serializers.decimal,
    lifetimeLimit: Serializers.decimal,
    dryRun: Serializers.boolean,
  }),
  valueSerializer: emitGiftPointsResultSerializer,
});

const claimGiftPoints = HttpAction({
  path: "/giftPoints/claim",
  method: "post",
  requiresAuth: true as const,
  bodySerializer: Serializers.object({}),
  errorSerializer: Serializers.stringOneOf("NoUnclaimedGiftPoints"),
});

export const giftPointActions = {
  emitGiftPoints,
  claimGiftPoints,
};
